export default {
  label: 'Autores',
  placeholder: 'Todos',
  other: 'otro',
  others: 'otros',
  all: 'Todos',
  filtered: 'filtrado',
  filteredPlural: 'filtrados',
  negated: 'negativado',
  negatedPlural: 'negativados',
};
